import {Injectable} from "@angular/core";
import {from, map, Observable} from "rxjs";

@Injectable({providedIn: 'root'})
export class GeolocationService {

  private readonly BASE_URL = 'https://nominatim.openstreetmap.org/reverse?format=json&addressdetails=1';

  getLocationInfo(lat: number, lon: number): Observable<Address | undefined> {
    const url = `${this.BASE_URL}&lat=${lat}&lon=${lon}`;
    return from(fetch(url).then((res) => res.json())).pipe(
      map((data) => {
        return mapAddress(data);
      })
    );
  }
}

export interface NominatimResponse {
  place_id?: number;
  lat?: string;
  lon?: string;
  address?: NominatimAddress;
}

export interface NominatimAddress {
  road?: string;
  house_number?: string;
  city?: string;
  town?: string;
  village?: string;
  country?: string;
  city_district?: string;
  country_code?: string;
  postcode?: string;
}


export class Address {
  street?: string;
  city?: string;
  country?: string;
  country_code?: string;
  postcode?: string;
  lat?: string;
  lon?: string;
}



export function mapAddress(response: NominatimResponse | undefined): Address | undefined {
  if (!response) return;

  const { lat, lon, address } = response;
  const result = new Address();

  result.lat = lat;
  result.lon = lon;

  if (!address) return result;

  const cityKeys: (keyof NominatimAddress)[] = ['village', 'town', 'city_district','city'];

  for (const key of cityKeys) {
    if (address[key]) {
      result.city = address[key];
      break;
    }
  }

  const street = [address.road, address.house_number].filter(Boolean).join(' ');
  result.street = street || undefined;
  result.country = address.country;
  result.country_code = address.country_code;
  result.postcode = address.postcode;
  return result;
}
